// Captured once per document so in-preview navigation keeps the chrome-less layout.
export const EMBEDDED = typeof window !== "undefined" && window.self !== window.top
  && new URLSearchParams(window.location.search).get("embedded") === "1";

// A same-app Copilot conversation to return to after a trial or report (never an external URL).
export const copilotReturn = () => {
  const r = new URLSearchParams(window.location.search).get("return");
  return r && /^\/copilot\/[\w-]+$/.test(r) ? r : null;
};

// Full-screen steps (trial, report, publish) leave the Copilot preview frame and come back to the conversation.
export const goTop = (nav, url) => {
  if (!EMBEDDED) return nav(url);
  const back = window.top.location.pathname;
  const sep = url.includes("?") ? "&" : "?";
  window.top.location.assign(/^\/copilot\/[\w-]+$/.test(back) ? `${url}${sep}return=${encodeURIComponent(back)}` : url);
};
